import { CustomData, EventRequest, UserData, ServerEvent } from 'facebook-nodejs-business-sdk';

const access_token: string = process.env.NEXT_PUBLIC_META_ACCESS_TOKEN || '';
const pixel_id: string = process.env.NEXT_PUBLIC_META_PIXEL_ID || '';

interface ConversionData {
    email?: string;
    phone?: string;
    name?: string;
    ipaddress: string;
    useragent: string;
    url: string;
    pageViewCustomProps?: PageViewCustomProps;
}

interface PageViewCustomProps {
    courseId?: string;
    mentorDetails?: string;
}


async function fireConversionApi(data: ConversionData, eventName: string) {
        try {
            const {
                ipaddress,
                useragent,
                url,
                pageViewCustomProps,
            } = data;

            if (!access_token || !pixel_id) {
                throw new Error('Missing access token or pixel ID');
            }
    
            if (!ipaddress || !useragent || !url) {
                throw new Error('Missing required fields: ipaddress, useragent, or url');
            }
    
            let current_timestamp = Math.floor(new Date().getTime() / 1000);
            
            const userData = (new UserData())
                .setClientIpAddress(ipaddress)
                .setClientUserAgent(useragent);

            const customData = (new CustomData())
            
            if (pageViewCustomProps) {
                customData.setCustomProperties(pageViewCustomProps);
            }
            
            const serverEvent = (new ServerEvent())
                .setEventName(eventName)
                .setEventTime(current_timestamp)
                .setUserData(userData)
                .setCustomData(customData)
                .setEventSourceUrl(url)
                .setActionSource("website");
                
            const eventsData = [serverEvent];
            
            const eventRequest = (new EventRequest(access_token, pixel_id)).setEvents(eventsData);
            
            eventRequest.execute().then(
                response => {
                    console.log('Response:', response);
                },
                err => {
                    console.error('Error here:', err);
                }
            ).catch(error => {
                console.error('Caught Error:', error);
            });
        } catch (error) {
            console.log('Page View Event Firing failed : ', error);
        }
    }


export default fireConversionApi;
